import { getSizesAbstract } from './get-sizes-abstract.js';
import type { Point } from '../../../core/types/point.js';
import { NON_OVERLAPPING_HEIGHT } from '../../constants.js';
import type { HoneycombTileShape } from '../../types/honeycomb.js';
import { isEven } from '../hive-helpers.js';

export const calculateTileCenter = (
  shape: HoneycombTileShape,
  width: number,
  gridPosition: Point,
  gap: number,
  offset: { top: number; left: number } = { top: 0, left: 0 },
) => {
  const { halfWidth, halfHeight, height } = getSizesAbstract(shape, width);
  const adjustedHorizontalPosition = gridPosition.x - 1;
  const adjustedVerticalPosition = gridPosition.y - 1;

  const horizontalOffsetOddLines =
    width * adjustedHorizontalPosition + offset.left;

  const horizontalOffset = isEven(gridPosition.y)
    ? horizontalOffsetOddLines + halfWidth + gap / 2
    : horizontalOffsetOddLines;

  const heightWithoutFirstLine =
    adjustedVerticalPosition * NON_OVERLAPPING_HEIGHT[shape];
  const verticalOffset = height * heightWithoutFirstLine + offset.top;

  return {
    y: verticalOffset + halfHeight + gap * adjustedVerticalPosition,
    x: horizontalOffset + halfWidth + gap * adjustedHorizontalPosition,
  };
};
